import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from "@ui/components/accordion";

/** Questions buyers ask, answered plainly. Also published as FAQPage structured data. */
export const HOME_FAQ: { q: string; a: string }[] = [
	{
		q: "What is an AI shopping assistant?",
		a: "An AI shopping assistant talks with shoppers in plain language, searches the store's catalog for them and builds their basket. Hephon Commerce works from your live catalog, prices and stock, so it only offers what you can actually deliver.",
	},
	{
		q: "Which languages does it speak?",
		a: "Arabic and English first. It understands Saudi and Gulf Arabic as people write and speak them, in chat and on calls, and answers in the language it was asked in. It also speaks Lebanese Arabic, Arabizi (Arabic typed in Latin letters) and French.",
	},
	{
		q: "Can it work as an Arabic chatbot on WhatsApp?",
		a: "Yes. Connect your WhatsApp Business number and the same agent answers in Arabic or English, sends product cards and a checkout the shopper confirms, and can take WhatsApp voice calls.",
	},
	{
		q: "Which catalogs and platforms does it connect to?",
		a: "The ecommerce platform you already run, a product feed, or our REST API with webhooks, plus an SDK for iOS, Android and the web. For other platforms we build a connector. Each branch can keep its own prices and stock. The Integrations page lists them.",
	},
	{
		q: "Can it take orders?",
		a: "It builds the basket and the checkout, and the shopper confirms. The order then goes to your platform through its API, or to your team as an order ticket. Nothing is ever ordered without the shopper's confirmation.",
	},
	{
		q: "What happens when it cannot help?",
		a: "It hands the conversation to your team. Every conversation is in your inbox, and a person can take over the same chat at any time.",
	},
	{
		q: "How is Hephon Commerce priced?",
		a: "Pricing depends on your stores and the channels you use. Book a demo and we will send you a proposal.",
	},
];

export function Faq({
	items = HOME_FAQ,
	title = "Questions retailers ask first.",
}: {
	items?: { q: string; a: string }[];
	title?: string;
}) {
	return (
		<section
			aria-labelledby="faq-title"
			className="mk-section bg-(--mk-mist)"
		>
			<div className="mk-container grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
				<h2 id="faq-title" className="mk-h2 mk-reveal">
					{title}
				</h2>
				<Accordion className="mk-reveal rounded-none border-0 border-(--mk-mist-2) border-t">
					{items.map((item) => (
						<AccordionItem
							key={item.q}
							value={item.q}
							className="border-(--mk-mist-2) border-b data-open:bg-transparent"
						>
							<AccordionTrigger className="py-5 text-start font-medium text-(--mk-ink) text-[17px] tracking-[-0.01em] hover:no-underline sm:text-[19px]">
								{item.q}
							</AccordionTrigger>
							{/* Answers stay in the server HTML (hidden until opened or found), so search
							    engines and AI crawlers read them, not only the questions. */}
							<AccordionContent
								hiddenUntilFound
								className="pb-6 text-(--mk-ink-2) text-[16px] leading-relaxed"
							>
								{item.a}
							</AccordionContent>
						</AccordionItem>
					))}
				</Accordion>
			</div>
		</section>
	);
}
